'use strict';
/**
 * @ngdoc function
 * @name gfcmsApp.controller:ProfileDetailsCtrl
 * @description
 * # ProfileDetailsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('JobCompleteCtrl', JobCompletionController);

JobCompletionController.$inject = [
  '$http', '$window', '$location', '$timeout', '$routeParams',
  'cfpLoadingBar', 'Upload', 'jobService', 'scheduleService', 'eventsService',
  'FlashService', 'permissionService', 'jobUpdateInfo'
];

/**
 * @param $http
 * @param $window
 * @param $location
 * @param $timeout
 * @param $routeParams
 * @param {cfpLoadingBar} cfpLoadingBar
 * @param Upload
 * @param {JobService} jobService
 * @param scheduleService
 * @param eventsService
 * @param {FlashService} FlashService
 * @param permissionService
 * @param { JobUpdateInfo } jobUpdateInfo
 * @return {JobCompletionController}
 * @constructor
 */
function JobCompletionController($http, $window, $location, $timeout, $routeParams,
                                 cfpLoadingBar, Upload, jobService, scheduleService, eventsService,
                                 FlashService, permissionService, jobUpdateInfo) {


  var completeJobsVm = this;

  completeJobsVm.statuses = jobUpdateInfo.statusMap;

  var files = [];
  var properties = {
    jobId: $routeParams.jobId,
    statuses: jobUpdateInfo.statusMap
      .map(function (jobStatus) {
        return {
          text: jobStatus.status,
          value: jobStatus.value
        };
      }),
    arrived: jobUpdateInfo.arrived,
    services: jobUpdateInfo.maintenanceServices
      .concat(jobUpdateInfo.lawnCareServices)
      .map(function (value) {
        return {
          name: value,
          selected: false
        };
      }),
    customerInfo: jobUpdateInfo.customerInfo,
    job: {
      id: $routeParams.jobId,
      arrived: jobUpdateInfo.arrived,
      isUpdating: false,
      updating: function () {
        this.isUpdating = true;
      },
      updated: function () {
        this.isUpdating = false;
      }
    }
  };

  var data = {
    jobId: undefined,
    status: undefined,
    notes: undefined,
    workCompleted: undefined,
    reason: undefined
  };

  function getWorkCompleted() {
    return completeJobsVm.properties.services
      .filter(function (value) {
        return value.selected;
      })
      .map(function (value) {
        return value.name;
      });
  }

  /**
   * @type {{"2": (function(): Promise<unknown>), "3": (function(): Promise<unknown>)}}
   */

  /**
   * @type {{"2": (function(): Promise<unknown>),
   * "3": (function(): Promise<unknown>),
   * "4": (function(): Promise<unknown>),
   * "5": (function(): Promise<unknown>),
   * "6": (function(): Promise<unknown>)}}
   */
  var completionFunctionMap = {
    2: completeJob,
    3: partlyCompleteJob,
    4: jobInterrupted,
    5: jobRescheduled,
    6: jobCancelled
  };

  completeJobsVm.completeJob = completeJob;
  completeJobsVm.refresh = activate;
  completeJobsVm.updateJobStatus = updateJobStatus;
  completeJobsVm.customerNotesRequired = customerNotesRequired;
  completeJobsVm.reasonRequired = reasonRequired;
  completeJobsVm.workCompletedRequired = workCompletedRequired;
  completeJobsVm.picturesRequired = picturesRequired;
  completeJobsVm.removeFile = removePicture;
  completeJobsVm.selectionChanged = selectionChanged;
  completeJobsVm.properties = properties;
  completeJobsVm.data = data;
  completeJobsVm.files = files;

  return completeJobsVm;

  function activate() {
  }


  function updateJobStatus() {
    completionFunctionMap[data.status]()
      .then();
  }

  /**
   * @return {Promise<any>}
   */
  function completeJob() {
    /**
     * @type {JobCompletion}
     */
    var jobCompletion = {
      jobId: properties.jobId,
      customerNotes: data.notes,
      workCompleted: data.workCompleted,
      pictures: completeJobsVm.files
    };

    requestStart();
    return jobService.completeJob(jobCompletion)
      .then(function () {
        FlashService.Success('Job Completed!');
        $location.path(getRedirectRoute());
      })
      .catch(function (reason) {
        FlashService.Error('Job Completion Failed!');
      })
      .finally(requestComplete);
  }

  /**
   * @return {Promise<any>}
   */
  function partlyCompleteJob() {
    /**
     * @type {JobPartCompletion}
     */
    var jobPartCompletion = {
      jobId: properties.jobId,
      notCompletedReason: data.reason,
      workCompleted: data.workCompleted,
      pictures: completeJobsVm.files
    };

    requestStart();
    return jobService.partlyCompleteJob(jobPartCompletion)
      .then(function () {
        FlashService.Success('Job Partly Completed!');
        $location.path(getRedirectRoute());
      })
      .catch(function (reason) {
        FlashService.Error('Job Update Failed!');
      })
      .finally(requestComplete);
  }

  /**
   * @return {Promise<any>}
   */
  function jobInterrupted() {
    /**
     * @type {JobInterruption}
     */
    var jobInterruption = {
      jobId: properties.jobId,
      notCompletedReason: data.reason,
      workCompleted: data.workCompleted,
      pictures: completeJobsVm.files
    };

    requestStart();
    return jobService.interruptedJob(jobInterruption)
      .then(function () {
        FlashService.Success('Job interruption recorded!');
        $location.path(getRedirectRoute());
      })
      .catch(function (reason) {
        FlashService.Error('Job Update Failed!');
      })
      .finally(requestComplete);
  }

  /**
   * @return {Promise<any>}
   */
  function jobCancelled() {
    /**
     * @type {JobCancellation}
     */
    var jobCancellation = {
      jobId: properties.jobId,
      notCompletedReason: data.reason,
      workCompleted: data.workCompleted
    };

    requestStart();
    return jobService.cancelledJob(jobCancellation)
      .then(function () {
        FlashService.Success('Job cancellation recorded!');
        $location.path(getRedirectRoute());
      })
      .catch(function (reason) {
        FlashService.Error('Job Update Failed!');
      })
      .finally(requestComplete);
  }

  /**
   * @return {Promise<any>}
   */
  function jobRescheduled() {
    /**
     * @type {JobRescheduled}
     */
    var jobRescheduledParams = {
      jobId: properties.jobId,
      notCompletedReason: data.reason,
      workCompleted: data.workCompleted
    };

    requestStart();
    return jobService.rescheduledJob(jobRescheduledParams)
      .then(function () {
        FlashService.Success('Job reshedule recorded!');
        $location.path(getRedirectRoute());
      })
      .catch(function (reason) {
        FlashService.Error('Job Update Failed!');
      })
      .finally(requestComplete);
  }

  /**
   * @return { boolean }
   */
  function customerNotesRequired() {
    return completeJobsVm.data.status === 2;
  }

  /**
   * @return { boolean }
   */
  function reasonRequired() {
    var uncompletedStatuses = [3, 4, 5, 6];
    return uncompletedStatuses.indexOf(completeJobsVm.data.status) > -1;
  }

  /**
   * @return { boolean }
   */
  function workCompletedRequired() {
    var completionStatuses = [2, 3, 4];
    return completionStatuses.indexOf(completeJobsVm.data.status) > -1;
  }

  /**
   * @return { boolean }
   */
  function picturesRequired() {
    return workCompletedRequired() && completeJobsVm.files.length < 2;
  }

  function removePicture(file) {
    var index = completeJobsVm.files.indexOf(file);
    if (index > -1) {
      completeJobsVm.files.splice(index, 1);
    }
  }

  function selectionChanged() {
    data.workCompleted = getWorkCompleted(properties.services);
  }

  function requestComplete() {
    $timeout(properties.job.updated.bind(properties.job), 2000);
  }

  function requestStart() {
    properties.job.updating();
  }

  function getRedirectRoute() {
    return permissionService.hasPermission('schedules.read') ?
      '/schedules/' + jobUpdateInfo.scheduleId
      : '/myschedules/' + jobUpdateInfo.scheduleId;
  }
}
